<template>
  <div class="my-4">
    <tree-navigation
      :items="items"
      class="treeDiv"
      dialogTitle="Browse Documentation"
    ></tree-navigation>
    <div style="height: 3em">&nbsp;</div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import TreeNavigation from "@/components/pagesStuff/TreeNavigation";
import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "DocumentationSidebar",
  components: { TreeNavigation },
  mixins: [GetJsonMixin],
  props: {},
  data: function () {
    return {
      // todo: get the menu from an API (after I make admin panel to get/set menu items in the DB)
      items: null,
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.getJSON("documentationMenu", "items"); // in the mixin
  },
};
</script>

<style scoped></style>
